<span class="header">
  <span class="column-name" data-cy="column-header-name"
    >{{ columnName }}
    <span
      *ngIf="hasSorting"
      class="sort-arrow"
      [class.sort-arrow--down]="isDesSort"
    ></span>
  </span>
</span>
